import * as React from 'react'
import * as s from './StatusBadge.css'

export type StatusVariant =
  | 'online'
  | 'standby'
  | 'offline'
  | 'fault'
  | 'commissioning'
  | 'enrolled'
  | 'pending'
  | 'none'

export type StatusSize = 'sm' | 'md'

export interface StatusBadgeProps {
  variant: StatusVariant
  size?: StatusSize
  label?: string
  showDot?: boolean
  className?: string
}

const DEFAULT_LABELS: Record<StatusVariant, string> = {
  online:        'Online',
  standby:       'Standby',
  offline:       'Offline',
  fault:         'Fault',
  commissioning: 'Commissioning',
  enrolled:      'Enrolled',
  pending:       'Pending',
  none:          '—',
}

export const StatusBadge = ({
  variant,
  size = 'md',
  label,
  showDot = true,
  className,
}: StatusBadgeProps) => {
  const text = label ?? DEFAULT_LABELS[variant]
  return (
    <span className={`${s.badge({ variant, size })}${className ? ` ${className}` : ''}`}>
      {showDot && variant !== 'none' && (
        <span className={s.dotVariant({ variant, size })} aria-hidden="true" />
      )}
      {text}
    </span>
  )
}
